import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ViToastService } from '@vi-iot/ui';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { SrcNotificationSettingsApi } from '../../../projects/client/apis/src-notification-settings/src-notification-settings.api';

import { SrcNotificationSettingsActions } from './src-notification-settings.actions';
import { SRC_NOTIFICATION_TYPE } from './src-notification-settings.state';

@Injectable()
export class SrcNotificationSettingsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly srcNotificationSettingsApi: SrcNotificationSettingsApi,
    private readonly translate: TranslateService,
    private readonly toast: ViToastService
  ) {}

  getSettings$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(SrcNotificationSettingsActions.getNotificationSettings.attempt),
      switchMap(({ installationId }) =>
        this.srcNotificationSettingsApi
          .getNotificationSetting(installationId, SRC_NOTIFICATION_TYPE)
          .pipe(
            map((response) =>
              SrcNotificationSettingsActions.getNotificationSettings.success({
                data: response.data,
              })
            ),
            catchError(() => {
              this.toast.error({
                message: this.translate.instant(
                  '+ACTIVE_ERROR_DETAILS_PAGE.WARNING_BOX.FAILED.HEADER'
                ),
              });

              return of(
                SrcNotificationSettingsActions.getNotificationSettings.error({
                  error: 'Failed to load notification settings',
                })
              );
            })
          )
      )
    );
  });

  setSettings$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(SrcNotificationSettingsActions.setNotificationSettings.attempt),
      switchMap(({ installationId, isEnabled, threshold }) =>
        this.srcNotificationSettingsApi
          .setNotificationSetting(installationId, SRC_NOTIFICATION_TYPE, isEnabled, threshold)
          .pipe(
            map((response) => {
              this.toast.info({
                message: this.translate.instant('+SCHEDULES.SNACKBAR.PROGRAM_SUCCESS'),
              });

              return SrcNotificationSettingsActions.setNotificationSettings.success({
                data: response.data,
              });
            }),
            catchError(() => {
              this.toast.error({
                message: this.translate.instant('+SCHEDULES.SNACKBAR.PROGRAM_FAILURE'),
              });

              return of(
                SrcNotificationSettingsActions.setNotificationSettings.error({
                  error: 'Failed to save notification settings',
                })
              );
            })
          )
      )
    );
  });
}
